import { Channel } from './channel.model';

export class ChannelResponse {
  channelList: Channel[];
  total: number;

  constructor(channelList: any, total: any) {
    this.channelList = channelList;
    this.total = total;
  }
}
